module.exports = __webpack_public_path__ + "static/media/Categoria1Mineria.5ed8e32a.jpg";